import { NgModule }      from '@angular/core';
import { KeysService }   from '../input-devices/keys.service';
import { UIStateEngine } from '../ui.state.engine';
import { InternalStateHelperService } from '../internal-state/internal-state.helper.service';
import { KeysDefaultBehavior } from '../input-devices/keys.default.behavior.service';
import { ScrollingHelperService } from '../scrolling/scrolling.helper.service';
import { UIAppHelper } from '../ui.app.helper'
import { MobileNavigationService } from '../mobile-navigation/mobile-navigation.service';
import { MediaCellOttService } from '../components/media-cell.ott.service'
import { InteractiveComponentService } from '../components/interactive-component.ott.service'
import { AppPlatformService } from '../app-platform.service'
import { VideoPlayerControlService } from "../videoplayer/videoplayer-control.service";

@NgModule({
  imports:      [ ],
  declarations: [ ],
  providers: [ 
    KeysService,
    KeysDefaultBehavior,
    ScrollingHelperService,
    UIStateEngine,
    InternalStateHelperService,
    UIAppHelper,
    MobileNavigationService,
    MediaCellOttService,
    AppPlatformService,
    InteractiveComponentService,
    VideoPlayerControlService

  ],
  exports:      [ ],
})
export class UiServicesModule {
}


// WEBPACK FOOTER //
// ./src/angular-engine/engine/service/ui/module/ui.services.module.ts